module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzAudio-72b8e474.jpg";